/** @format */

const hotelDetails = [
  {
    path: "",
    name: "hotel",
    meta: {
      breadcrumb: "hotel",
      title: "",
    },
    component: () => import('@/components/Hotel/Index'),
    props: true,
  },
  {
    path: "booking",
    name: "",
    props: true,
    component: () => import('@/components/Hotel/HotelBookingIndex'),
    children: [
      {
        path: "/",
        name: "form",
        component: () => import('@/components/Hotel/Details/OrderForm'),
        props: true,
      },
      {
        path: "payment",
        name: "hotel-payment",
        component: () => import('@/components/Hotel/Details/HotelPayment'),
        props: true
      },
      // ******
      // new route for payment-confirmation
      // to follow this format 
      // /booking/payment/mcbjuice/thank-you?ref={BookingRef}
      // ******
      {
        path: "payment/:paymentMethod/:response",
        name: "hotel-payment-confirmation",
        component: () => import('@/components/Hotel/Details/OrderConfirmation'),
        props: true
      }
    ],
  },
  {
    path: "hotel-booking-confirmation",
    name: "hotel-booking-confirmation",
    component: () => import('@/components/Hotel/Details/OrderConfirmation'),
    props: true,
  },
  {
    path: "hotelbooking",
    name: "",
    props: true,
    component: () => import('@/components/Hotel/Details/SignixHotelBookingIndex'),
    children: [
      {
        path: "/",
        name: "signix-form",
        component: () => import('@/components/Hotel/Details/SignixOrderFrom'),
        props: true,
      },
      {
        path: "payment",
        name: "signix-hotel-payment",
        component: () => import('@/components/Hotel/Details/SignixHotelPayment'),
        props: true
      },
      // {
      //   path: "confirm-booking:paymentMethod/:response",
      //   name: "signix-hotel-booking-confirmation",
      //   component: () => import('@/components/Hotel/Details/SignixHotelConfirmationPage'),
      //   props: true
      // }
    ],
  },
];
export default hotelDetails;
